export enum BlockType {
  QUESTION,
  STORY,
}
